import { GLOBAL_FETCH_SIGNAL, fetchUrl } from './settings';

import { ActionType } from '../action-types';
import { getNodes } from './actions';

export const editNode = (id, name, updatedViaWebsiteAt, systemId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');

	dispatch({ type: ActionType.EDITING_TOGGLE, payload: true });
	fetch(`${fetchUrl}/node/node-name`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({
			id: id,
			name: name,
			updatedViaWebsiteAt: updatedViaWebsiteAt,
		}),
	})
		.then((resp) => {
			return resp.json();
		})
		.then((data) => {
			if (!data.succeeded) {
				return Promise.all([dispatch(settingNewNodeNameFailed())]);
			} else {
				return Promise.all([
					dispatch({
						type: ActionType.SETTING_NEW_NODE_NAME_SUCCESS,
						id: id,
						name: name.trim(),
						updatedViaWebsiteAt: data.updatedViaWebsiteAt,
					}),
				]).then(() => {
					dispatch(getNodes([systemId]));
				});
			}
		})
		.catch((err) => {
			console.error(err);
		});
};

export const closeSettingNewNodeNameCard = () => (dispatch) => {
	return dispatch({ type: ActionType.CLOSE_SETTING_NEW_NODE_NAME_CARD });
};

export const settingNewNodeNameFailed = () => (dispatch) => {
	return dispatch({ type: ActionType.SETTING_NEW_NODE_NAME_FAILED });
};

export const editingOn = (isEditing) => (dispatch) => {
	return dispatch({ type: ActionType.EDITING_TOGGLE, payload: isEditing });
};
